import { z } from "zod"

// export interface NameEntity extends Entity {
//   name: string
// }

// export type EntityForm<T extends Entity, P extends keyof T> = Pick<T, P> & { id: ID }

// Entity
export const EntitySchema = z.object({
  id: z.string(),
  name: z.string().min(3),
  workspace_id: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
})

export type Entity = z.infer<typeof EntitySchema>

// Named Entity
export const NamedEntitySchema = EntitySchema.extend({ name: z.string().min(3) })
export type NamedEntity = z.infer<typeof NamedEntitySchema>
